import React, { CSSProperties, FunctionComponent } from "react";
import Helmet from "react-helmet";
import { withPrefix } from "gatsby";
import { useSiteMetadata } from "../hooks/useSiteMetadata";
import { CompactHeader, Masthead } from "./header";
import { Footer } from "./footer";

const FONTS =
  "https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,400;12..96,600;12..96,800&family=Literata:ital,opsz,wght@0,7..72,400;0,7..72,600;1,7..72,400&family=JetBrains+Mono:wght@400;500;700&display=swap";

const footer: Footer = {
  copyrightOwner: "Nahuel Taibo",
  links: [
    { label: "GitHub", href: "https://github.com/nahueltaibo" },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/nahueltaibo/" },
    { label: "RSS", href: "/rss.xml" },
  ],
};

export interface Layout {
  /** Full-size wordmark header, used on the home page only. */
  masthead?: boolean;
  style?: CSSProperties;
}

export const Layout: FunctionComponent<Layout> = ({
  masthead,
  style,
  children,
}) => {
  const { title } = useSiteMetadata();
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix("/")}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-16x16.png`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix("/")}img/safari-pinned-tab.svg`}
          color="#ffffff"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin=""
        />
        <link rel="stylesheet" href={FONTS} />
        <meta name="theme-color" content="#fff" />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="taibo.ca"
          href={`${withPrefix("/")}rss.xml`}
        />
      </Helmet>
      <div className="mx-auto max-w-site bg-paper" style={style}>
        {masthead ? <Masthead /> : <CompactHeader />}
        <main className="min-h-screen">{children}</main>
        <Footer {...footer} />
      </div>
    </>
  );
};

export default Layout;
